// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__vbrmR","date":"Tooltip_date__K+YvJ","texts":"Tooltip_texts__mBMWu","label":"Tooltip_label__vidoy"};